import "./courses.css";
import CourseCard from "../../components/course_card";
import Layout from "../../layout";
import useCourses from "../../hooks/use_courses";
import { useEffect } from "react";
import LoadingPrimary from "../../assets/animations/loading_primary.svg";
import Skeleton from "../../components/skeleton";
import Button from "antd/lib/button";
import { useNavigate } from "react-router-dom";
import Empty from "antd/lib/empty";
import { useSelector } from "react-redux";

const Courses = () => {
  const navigate = useNavigate();
  const {
    // entity methods
    getCourses,
    // entity states
    courses,
    // controller states
    paginates,
    // loading states
    loadings,
  } = useCourses();

  const userProfile = useSelector((state) => state.app.userProfile);

  useEffect(() => {
    if (userProfile) {
      getCourses(1);
    }
  }, [userProfile]);

  return (
    <Layout>
      <div className="courses">
        <h3>My Courses</h3>
        <div className="courses_list">
          {loadings.getCourses
            ? Array(3)
                .fill()
                .map((item, index) => (
                  <Skeleton
                    key={index}
                    style={{ borderRadius: 8, height: 465 }}
                  />
                ))
            : [...courses]
                .sort((a, b) => {
                  const order = { 1: 0, 2: 1, 0: 2 }; // Verified -> Pending -> Rejected
                  return order[a.status] - order[b.status];
                })
                .map((course, index) => (
                  <CourseCard data={course} key={index} />
                ))}
        </div>
        {!loadings.getCourses && courses.length == 0 ? (
          <Empty
            description="No courses founded"
            style={{
              width: "100%",
              padding: "48px 0",
            }}
          />
        ) : null}
        <div className="create_coupon_modal_btn">
          <Button
            onClick={() => {
              navigate("/courses/new");
            }}
          >
            New Course
          </Button>
        </div>
      </div>
      {paginates.has_more ? (
        <div className="courses_list_pagination">
          {loadings.getCoursesPaginates ? (
            <img src={LoadingPrimary} alt="Loading..." />
          ) : (
            <div
              onClick={() => {
                getCourses(paginates.current + 1);
              }}
            >
              Load more
            </div>
          )}
        </div>
      ) : null}
    </Layout>
  );
};

export default Courses;
